import { AdminProvider } from "./context/AdminContext";
import { ApiKeyProvider } from "./context/ApiKeyContext";
import { AuthProvider } from "./context/AuthContext";
import { MemberProvider } from "./context/MemberContext";
import { CityProvider } from "./context/CityContext";
import { ClientProvider } from "./context/ClientContext";
import { OrderProvider } from "./context/OrderContext";
import { ProfileProvider } from "./context/ProfileContext";
import { RiderProvider } from "./context/RiderContext";
import { StatsProvider } from "./context/StatsContext";
import { PartnerProvider } from "./context/PartnerContext";
import { MissionProvider } from "./context/MissionContext";

import composeProviders from "./utils/composeProviders";

const ContextProvider = composeProviders(
  AuthProvider,
  MemberProvider,
  OrderProvider,
  ClientProvider,
  ProfileProvider,
  CityProvider,
  RiderProvider,
  AdminProvider,
  PartnerProvider,
  StatsProvider,
  MissionProvider,
  ApiKeyProvider
);

export default ContextProvider;
